import { useAtom } from '@reatom/npm-react'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { Result } from '@blade/std-lib'
import { CircularLoader } from '@blade/ui-kit'
import { currentThemeAtom } from '@root/shared/theme/atoms/current-theme-atom'

import { loadBlueskyWidget } from './load-bluesky-widget'

type Props = {
  html: string
}

export const BlueskyEmbedPost = ({ html }: Props) => {
  const [currentTheme] = useAtom(currentThemeAtom)
  const ref = useRef<HTMLDivElement>(null)

  const template = document.createElement('template')
  template.innerHTML = html

  const original = template.content.querySelector('blockquote')

  const uri = original?.dataset.blueskyUri
  const cid = original?.dataset.blueskyCid

  useEffect(() => {
    if (!ref.current) {
      return
    }

    loadBlueskyWidget().then((result) => {
      if (Result.isFailure(result)) {
        return
      }

      result.success.scan(ref.current ?? undefined)
    })
  }, [currentTheme.appearance])

  if (!uri) {
    return undefined
  }

  return (
    <Root ref={ref}>
      <LoaderBackdrop>
        <CircularLoader size={24} />
      </LoaderBackdrop>
      <blockquote
        data-bluesky-uri={uri}
        data-bluesky-cid={cid}
        data-bluesky-embed-color-mode={currentTheme.appearance}
      />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  width: 350px;
  border-radius: 32px;
  border: 1px solid var(--background-6);
  max-height: var(--viewport-height);
  overflow: auto;
  margin: 0 !important;
  & .bluesky-embed {
    position: relative;

    margin: 0 !important;
  }
`

const LoaderBackdrop = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  pointer-events: none;
`
